<script>
  import { _ } from "svelte-i18n";
  export let user;
  export let showReportWithType;
  export let showErrorMessage;
</script>

<fieldset class="form-section">
  <h3>{$_("profile.form.privacy.title")}</h3>
  <div class="checkbox-terms">
    <label class="checkbox" for="termsOfService"
      ><input
        type="checkbox"
        class="checkbox__input-hidden"
        id="termsOfService"
        name="termsOfService"
        bind:checked={user.termsOfService}
      /><span class="checkbox__input-custom" /><span class="checkbox__label"
      ></span></label
    >
    <p>
      {$_("profile.form.privacy.terms.text")}
      <a
        style="text-decoration:underline; cursor:pointer;"
        on:click={() => {
          showReportWithType = "termsOfService";
        }}>{$_("profile.form.privacy.terms.link")}.</a
      >
    </p>
  </div>
  {#if showErrorMessage && !user.termsOfService}
    <span class="form-error is-visible"
      >{$_("profile.form.privacy.terms.error")}</span
    >
  {/if}
  <div class="checkbox-terms">
    <label class="checkbox" for="healthDataConsent"
      ><input
        type="checkbox"
        class="checkbox__input-hidden"
        id="healthDataConsent"
        name="healthDataConsent"
        bind:checked={user.healthDataConsent}
      /><span class="checkbox__input-custom" /><span class="checkbox__label"
      ></span></label
    >
    <p>
      {$_("profile.form.privacy.health.text")}
      <a
        style="text-decoration:underline; cursor:pointer;"
        on:click={() => {
          showReportWithType = "healthAgreement";
        }}>{$_("profile.form.privacy.health.link")}.</a
      >
    </p>
  </div>
  {#if showErrorMessage && !user.healthDataConsent}
    <span class="form-error is-visible"
      >{$_("profile.form.privacy.health.error")}</span
    >
  {/if}
  <div class="checkbox-terms">
    <label class="checkbox" for="privacy"
      ><input
        type="checkbox"
        class="checkbox__input-hidden"
        id="privacy"
        name="privacy"
        bind:checked={user.privacy}
      /><span class="checkbox__input-custom" /><span class="checkbox__label"
      ></span></label
    >
    <p>
      {$_("profile.form.privacy.privacy.text")}
      <a
        style="text-decoration:underline; cursor:pointer;"
        on:click={() => {
          showReportWithType = "privacy";
        }}>{$_("profile.form.privacy.privacy.link")}.</a
      >
    </p>
  </div>
  {#if showErrorMessage && !user.privacy}
    <span class="form-error is-visible"
      >{$_("profile.form.privacy.privacy.error")}</span
    >
  {/if}
</fieldset>
